import * as Yup from "yup";
import {
  PAYER_CITY_REGEX,
  PAYER_FIELD_LABEL,
  PAYER_FIELD_LENGTH,
  PAYER_ID_REGEX,
  PAYER_MESSAGES,
  PAYER_NAME_LETTER_REGEX,
  PAYER_ZIP_REGEX,
} from "./payers-constant";

const requiredMessage = (label: string) => `${label} is required`;
const maxMessage = (label: string, max: number) =>
  `${label} must be at most ${max} characters`;

const requiredText = (label: string, max: number) =>
  Yup.string()
    .trim()
    .required(requiredMessage(label))
    .max(max, maxMessage(label, max));

export const payerValidationSchema = Yup.object({
  payerId: requiredText(
    PAYER_FIELD_LABEL.PAYER_ID,
    PAYER_FIELD_LENGTH.PAYER_ID
  ).matches(PAYER_ID_REGEX, PAYER_MESSAGES.PAYER_ID_INVALID),
  payerName: requiredText(
    PAYER_FIELD_LABEL.PAYER_NAME,
    PAYER_FIELD_LENGTH.PAYER_NAME
  ).matches(PAYER_NAME_LETTER_REGEX, PAYER_MESSAGES.NAME_INVALID),
  payerType: Yup.string().required(
    requiredMessage(PAYER_FIELD_LABEL.PAYER_TYPE)
  ),
  address: Yup.object({
    line1: requiredText(
      PAYER_FIELD_LABEL.ADDRESS_LINE_1,
      PAYER_FIELD_LENGTH.ADDRESS_LINE
    ),
    line2: Yup.string()
      .trim()
      .max(
        PAYER_FIELD_LENGTH.ADDRESS_LINE,
        maxMessage(
          PAYER_FIELD_LABEL.ADDRESS_LINE_2,
          PAYER_FIELD_LENGTH.ADDRESS_LINE
        )
      ),
    city: requiredText(PAYER_FIELD_LABEL.CITY, PAYER_FIELD_LENGTH.CITY).matches(
      PAYER_CITY_REGEX,
      PAYER_MESSAGES.CITY_INVALID
    ),
    state: Yup.string().required(requiredMessage(PAYER_FIELD_LABEL.STATE)),
    country: Yup.string().required(requiredMessage(PAYER_FIELD_LABEL.COUNTRY)),
    zipcode: Yup.string()
      .trim()
      .required(requiredMessage(PAYER_FIELD_LABEL.ZIP_CODE))
      .matches(PAYER_ZIP_REGEX, PAYER_MESSAGES.ZIP_INVALID),
  }),
});
